module.exports = {
    sentryDsn: '',
    release: '4.9',
    tracesSampleRate: 0.9,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    propagationTarget: 'http://localhost:5000',
}